import * as React from "react";
import PropTypes from "prop-types";
import Backbone from "backbone";
import SlideToUnlock from "nx-components/SlideToUnlock";
import CommonControlWrapper from "nexia_mobile/components/Controls/wrappers/CommonControlWrapper";

export default class Barrier extends React.Component {
  static propTypes = {
    model: PropTypes.instanceOf(Backbone.Model).isRequired,
    isDetailed: PropTypes.bool.isRequired,
    showSpinner: PropTypes.func.isRequired, // (?string) => void
    hideSpinner: PropTypes.func.isRequired, // () => void
  };

  state = {
    pendingClosedValue: null,
  };

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  _setPendingClosedValue(pendingClosedValue) {
    if (!this._isMounted) {
      return;
    }
    this.setState({ pendingClosedValue });
  }

  render() {
    const { model, isDetailed, showSpinner, hideSpinner } = this.props;
    const { pendingClosedValue } = this.state;

    const closed =
      pendingClosedValue == null ? model.isBarrierClosed() : pendingClosedValue;

    return (
      <CommonControlWrapper isDetailed={isDetailed}>
        <SlideToUnlock
          locked={closed}
          lockedLabel="Closed"
          unlockedLabel="Open"
          disabled={!model.isBarrierOperable()}
          onChange={(newClosedValue) => {
            showSpinner(
              `${newClosedValue ? "Closing" : "Opening"} ${model.get("name")}`
            );
            this._setPendingClosedValue(newClosedValue);
            const onDone = () => {
              hideSpinner();
              this._setPendingClosedValue(null);
            };
            model.operateBarrier().then(onDone, onDone);
          }}
        />
      </CommonControlWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Controls/Barrier.jsx